import React from 'react';
import { SettingsHeader, SettingsPanel, AppRouter, Header, Footer } from './partials';
import { SiteWideNotice } from '../../reusablePartials';
import { getUrlQueryParams } from '../../actions';
import { useAppPipeline } from '../../hooks';

export default function Layout() {
	const urlParams = getUrlQueryParams();
	useAppPipeline({ urlParams });

	const showSimplified = JSON.parse(urlParams?.showSimplified || false);
	const showSwn = JSON.parse(urlParams.swn || 0);

	return (
		<>
			{!showSimplified ? <Header /> : null}
			<SettingsHeader />
			<SettingsPanel />
			<div className="uk-container">
				<AppRouter />
				{!showSimplified ? <Footer /> : null}
			</div>
			{showSwn === 1 ? <SiteWideNotice /> : null}
		</>
	);
}
